/**

 * LOT-UI-02 — Dashboard vendeur (POS-first, REP-V2).

 */

import React from 'react';

import { Link } from 'react-router-dom';

import { ShoppingCart, History, Users, Calculator } from 'lucide-react';

import { activiteTabUrl } from '../../utils/navigation/hubNavigation';

import { DASH_CTA, DASH_PANEL, DashboardSectionTitle } from '../../features/dashboard/dashboardV2Ui';



const VendeurDashboard = ({ stats, username }) => (

  <div className="space-y-5 max-w-lg mx-auto w-full" data-testid="dashboard-vendeur">

    <DashboardSectionTitle

      title={`Bonjour ${username || ''}`}

      subtitle={`${stats?.ventes_jour || 0} vente(s) aujourd'hui`}

    />

    <Link to="/pos-v2" className={DASH_CTA} data-testid="vendeur-pos-cta">

      <ShoppingCart className="w-12 h-12 text-red-400 mb-3" />

      <span className="text-xl font-bold text-white">Ouvrir la caisse / Vendre</span>

      <span className="text-sm text-gray-500 mt-1">Accès POS V2</span>

    </Link>

    <div className="grid grid-cols-3 gap-2">

      {[

        { to: activiteTabUrl('ventes', { period: '30d' }), icon: History, label: 'Activité', testId: 'vendeur-activite-link' },

        { to: '/clients', icon: Users, label: 'Clients' },

        { to: '/calcul', icon: Calculator, label: 'Calcul' },

      ].map(({ to, icon: Icon, label, testId }) => (

        <Link

          key={label}

          to={to}

          className={`${DASH_PANEL} flex flex-col items-center p-4 hover:border-white/20 transition-colors min-h-[88px] justify-center`}

          data-testid={testId}

        >

          <Icon className="w-6 h-6 text-gray-400 mb-1" />

          <span className="text-xs font-semibold text-gray-300">{label}</span>

        </Link>

      ))}

    </div>

  </div>

);



export default VendeurDashboard;

